import { z } from "zod"
import { ServiceAction } from "../service-part-action"

export const UpdatePartDefaultDurationSchema = z.object({
  action: z.nativeEnum(ServiceAction),
  durationMinutes: z.number().int().min(0),
})

export type UpdatePartDefaultDuration = z.infer<
  typeof UpdatePartDefaultDurationSchema
>
